window.$ = require('jquery');
window.jQuery = window.$;

$(function(){
      $('.js-toggle-collapsible').on('click', function(){
            $(this).toggleClass('common-questions__collapsible-header--visible');
      });
});